module.exports = __webpack_public_path__ + "static/media/asset4.0549d1f8.svg";